import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import Daypass from "./Daypass";
import BjjZurichLanding from "./landing-bjj-zurich-v2";
import BjjOver40Guide from "./landing-bjj-over-40";
import BjjRulesGuide from "./landing-bjj-rules";
import BjjFamilyGuide from "./landing-bjj-family";
import SeoLandingPage from "./landing-seo-pages";
import IntentLandingPage from "./landing-intent-pages";
import HomepageReviewsInjector from "./homepage-reviews";
import HomepageHallOfFameInjector from "./homepage-hall-of-fame";
import CrossrootsBranding from "./crossroots-branding";
import UniversalFooter from "./universal-footer";
import { SEO_PAGES } from "./seo-page-all-data";
import { INTENT_PAGES } from "./intent-page-data";
import { I18nProvider } from "./i18n";
import "./styles.css";
import "./landing-bjj-zurich.css";
import "./landing-seo-pages.css";
import "./landing-title-wrap-fix.css";
import "./homepage-reviews.css";
import "./landing-bjj-rules-fixes.css";
import "./landing-bjj-family.css";
import "./crossroots-branding.css";
import "./universal-footer.css";

const container = document.getElementById("root");
const initialLanguage = document.documentElement.lang.startsWith("en") ? "en" : "de";
const slug = window.location.pathname.replace(/^\/(de|en)\/?/, "").replace(/^\/+|\/+$/g, "");
const specialLandingSlugs = new Set(["bjj-zurich", "bjj-after-40-50", "bjj-rules", "bjj-familie"]);
const isLandingPage = specialLandingSlugs.has(slug) || Boolean(SEO_PAGES[slug]) || Boolean(INTENT_PAGES[slug]);

function CurrentPage() {
  if (slug === "daypass") return <Daypass />;
  if (slug === "bjj-zurich") return <BjjZurichLanding />;
  if (slug === "bjj-after-40-50") return <BjjOver40Guide />;
  if (slug === "bjj-rules") return <BjjRulesGuide />;
  if (slug === "bjj-familie") return <BjjFamilyGuide />;
  if (SEO_PAGES[slug]) return <SeoLandingPage pageId={slug} />;
  if (INTENT_PAGES[slug]) return <IntentLandingPage pageId={slug} />;
  return <><App /><HomepageReviewsInjector /><HomepageHallOfFameInjector /><CrossrootsBranding /></>;
}

const application = (
  <StrictMode>
    <I18nProvider initialLanguage={initialLanguage}>
      <CurrentPage />
      {isLandingPage && <UniversalFooter />}
    </I18nProvider>
  </StrictMode>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, application);
} else {
  createRoot(container).render(application);
}
